import BigNumber from 'bignumber.js';

import { ContractsManager, convertFromWei } from 'modules/core';

import { api } from '../api';
import { cacheTags } from '../cacheTags';

export const {
  useGetAccountBalanceQuery,
  endpoints: { getAccountBalance },
} = api.injectEndpoints({
  endpoints: build => ({
    getAccountBalance: build.query<BigNumber, { accountAddress: string }>({
      queryFn: async ({ accountAddress }) => {
        const sdk = await ContractsManager.getInstance();
        const contract = await sdk.getRegistryContract();

        const balance = await contract.methods
          .userBalance(accountAddress)
          .call();

        return { data: convertFromWei(balance) };
      },
      providesTags: [cacheTags.account, cacheTags.balance],
    }),
  }),
});
